<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="$store.state.settings.uniqueOpened"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in permission_routers" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/assets/styles/variables.scss'
import path from 'path'
import { isExternal } from '@/utils/validate'

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    activeMenu() {
      // const route = this.$route
      // const { meta, path } = route
      // // if set path, the sidebar will highlight the path you set
      // if (meta.activeMenu) {
      //   return meta.activeMenu
      // }
      // return path

      const route = this.$route
      const curpath = route.path
      let path = ''
      // 如果是登录进入选中第一个菜单
      if (curpath === '/') {
        // 选中第一个菜单
        path = this.getFirstMenu(this.permission_routers, '')
      } else {
        path = curpath
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  created() {
    // 首页进入第一个菜单
    this.$router.replace({ path: this.activeMenu })
  },
  methods: {
    // 得到第一个菜单链接
    getFirstMenu(routes, parentPath) {
      // console.log(routes)
      for (const item of routes) {
        if (!item.hidden) {
          let path = ''
          if (!item.alwaysShow) {
            if (parentPath) {
              path = this.resolvePath(parentPath, item.path)
            } else {
              path = this.resolvePath(item.path, item.children[0].path)
            }
          } else {
            path = this.getFirstMenu(item.children, item.path)
          }
          return path
        }
      }
    },
    resolvePath(basePath, routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(basePath)) {
        return basePath
      }
      return path.resolve(basePath, routePath)
    }

    // getMenuLink(path){
    //   for(let item of this.permission_routers){
    //     if(!item.alwaysShow){
    //       const parentPath= path.substring(0,path.indexOf('/',1));
    //       if(parentPath==item.path){
    //         return parentPath;
    //       }
    //     }
    //   }
    //   return path
    // }
  }
}
</script>
